module.exports = __webpack_public_path__ + "static/media/sportmonks.20d6c61d.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/sportmonks.webp
// module id = 825
// module chunks = 0